import React, { useEffect, useLayoutEffect } from 'react';
import cn from 'classnames';

import { useClickOutside, useEscPress } from '../util/hooks';

import IssueTeaser from './IssueTeaser';

import * as styles from './IssueIndex.module.css';

const IssueIndex = ({ isShowing = false, onClose, issues = [], children }) => {
  useLayoutEffect(() => {
    if (isShowing) {
      const originalStyle = window.getComputedStyle(document.body).overflow;
      document.body.style.overflow = 'hidden';

      return () => (document.body.style.overflow = originalStyle);
    }
  }, [isShowing]);

  const handleClose = () => {
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  useEscPress(() => {
    if (isShowing) handleClose();
  });

  const element = useClickOutside(handleClose);

  useEffect(() => {
    if (!isShowing || element.current === null) return;
    element.current.focus({ preventScroll: true });
  }, [isShowing, element]);

  return (
    <div className={cn(styles.root, { [styles.showing]: isShowing })}>
      <div className={cn(styles.overlay)} />
      <div
        ref={element}
        className={cn(styles.wrapper)}
        /* We want the tab index here to focus trap inside the list on open */
        /* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */
        tabIndex="0"
      >
        {children}
        {issues.map(issue => (
          <IssueTeaser
            key={issue.data.number}
            issue={issue.data}
            onClick={() => handleClose()}
          />
        ))}
      </div>
    </div>
  );
};

export default IssueIndex;
